import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Nav, Tab, Card } from "react-bootstrap";
import { FaBell, FaCommentDots, FaUserCircle } from "react-icons/fa";
import { db, auth } from "../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { AuthContext } from "../context/AuthProvider";  // Assuming you have AuthContext set up

const Chats = () => {
  const [activeTab, setActiveTab] = useState("notifications");
  const [notifications, setNotifications] = useState([]);
  const [chats, setChats] = useState([]);
  const { user } = useContext(AuthContext);  // Get user from AuthContext

  useEffect(() => {
    if (user) {
      // Fetch notifications for the user from Firestore
      const notificationsRef = collection(db, "notifications");
      const notificationsQuery = query(
        notificationsRef,
        where("userId", "==", user.uid)  // Ensure notifications are specific to the logged-in user
      );
      const unsubscribeNotifications = onSnapshot(notificationsQuery, (snapshot) => {
        const notificationsData = snapshot.docs.map((doc) => doc.data());
        setNotifications(notificationsData);
      });

      // Fetch chats for the user from Firestore
      const chatsRef = collection(db, "chats");
      const chatsQuery = query(
        chatsRef,
        where("users", "array-contains", user.uid)  // Chats that include the logged-in user
      );
      const unsubscribeChats = onSnapshot(chatsQuery, (snapshot) => {
        const chatsData = snapshot.docs.map((doc) => doc.data());
        setChats(chatsData);
      });

      // Cleanup function to unsubscribe from Firestore updates
      return () => {
        unsubscribeNotifications();
        unsubscribeChats();
      };
    }
  }, [user]);  // Effect runs when the user changes

  return (
    <>

      <Container fluid className="vh-100 d-flex flex-column">
        <Row className="flex-grow-1">
          {/* Sidebar */}
          <Col xs={3} className="bg-light p-3">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link
                  eventKey="notifications"
                  onClick={() => setActiveTab("notifications")}
                >
                  <FaBell size={20} /> Notifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="chats"
                  onClick={() => setActiveTab("chats")}
                >
                  <FaCommentDots size={20} /> Chats
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          {/* Main Content */}
          <Col xs={9} className="p-3">
            <Tab.Content>
              {/* Notifications Tab */}
              <Tab.Pane eventKey="notifications">
                <h5>Notifications</h5>
                <div>
                  {notifications.length === 0 ? (
                    <p>No notifications</p>
                  ) : (
                    notifications.map((notification, index) => (
                      <Card key={index} className="mb-3">
                        <Card.Body>
                          <Card.Text>{notification.message}</Card.Text>
                          <Card.Footer className="text-muted">{notification.time}</Card.Footer>
                        </Card.Body>
                      </Card>
                    ))
                  )}
                </div>
              </Tab.Pane>

              {/* Chats Tab */}
              <Tab.Pane eventKey="chats">
                <h5>Chats</h5>
                <div>
                  {chats.length === 0 ? (
                    <p>No chats available</p>
                  ) : (
                    chats.map((chat, index) => (
                      <Card key={index} className="mb-3">
                        <Card.Body>
                          <Row>
                            <Col xs={2}>
                              <FaUserCircle size={40} />
                            </Col>
                            <Col xs={8}>
                              <Card.Title>{chat.name}</Card.Title>
                              <Card.Text>{chat.lastMessage}</Card.Text>
                            </Col>
                            <Col xs={2} className="text-end">
                              <Card.Footer className="text-muted">
                                {chat.time}
                              </Card.Footer>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    ))
                  )}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Chats;
